import { getHighestUserRole } from 'lib-shared-user-role';
import { createSelector } from 'reselect';
export function selectUserModal(state) {
    return state.userModal;
}
export function selectUserModalUser(state) {
    return selectUserModal(state).user;
}
export const selectUserModalInitialValues = createSelector(selectUserModalUser, (user) => {
    var _a, _b, _c, _d;
    if (!user)
        return {};
    const initialValues = Object.assign(Object.assign({}, user), { display_name: user.name || user.display_name, emails: user.email
            ? [
                { value: user.email },
                ...((_b = (_a = user.additional_emails) === null || _a === void 0 ? void 0 : _a.map((value) => ({ value }))) !== null && _b !== void 0 ? _b : []),
            ]
            : [{ value: '' }], phone_numbers: user.phone_number
            ? [
                { value: user.phone_number },
                ...((_d = (_c = user.additional_phone_numbers) === null || _c === void 0 ? void 0 : _c.map((value) => ({ value }))) !== null && _d !== void 0 ? _d : []),
            ]
            : [{ value: '' }] });
    if (user.roles) {
        initialValues.role = getHighestUserRole(user.roles);
    }
    return initialValues;
});
